/**
 * Declare constants to use in UI
 */

export const Constants = {
  uuid: {
    clock: '00000000-0000-0000-0000-000000000001'
  },
  localStorage: {
    accessToken: 'access_token',
    username: 'username'
  }
}
